// libs
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

// components
import DetailApi from 'shared/layouts/DetailsPage/Api';
import Analytics from 'shared/layouts/DetailsPage/components/Analytics';
import DetailErrorWrapper from 'shared/layouts/DetailsPage/ErrorWrapper';
import ProductDetail from 'shared/layouts/DetailsPage/components/ProductDetail';
import WidgetProvider from 'shared/layouts/DetailsPage/components/WidgetProvider';
import WidgetLoader from 'shared/layouts/DetailsPage/components/WidgetLoader';
import MetaInfo from 'shared/layouts/DetailsPage/components/MetaInfo';
import BreadCrumb from 'shared/components/BreadCrumbs';
import ProductFaq from 'shared/layouts/DetailsPage/components/ProductFaq';

// selectors
import { getBreadCrumbs, getProductTitle } from 'shared/store/details/selectors';

// styles
import { Container } from './styles';

// hooks
import useInternalExp from 'shared/hooks/useInternalExp';
import { useProductInfo } from 'shared/layouts/DetailsPage/components/ProductInfo/hooks';

function DetailDesktop() {
  const breadCrumbs = useSelector(getBreadCrumbs);
  const productTitle = useSelector(getProductTitle);
  const isInternal = useInternalExp();
  const { brandLaunchingSoon } = useProductInfo();

  return (
    <DetailApi PDPApiV3={true} isMobile={false}>
      <DetailErrorWrapper>
        <MetaInfo />
        <Analytics isCategoryLaunchingSoon={!!brandLaunchingSoon} />
        <WidgetProvider>
          <Container>
            <BreadCrumb breadCrumbs={breadCrumbs} productTitle={productTitle} />
            <ProductDetail />
          </Container>
          <WidgetLoader />
        </WidgetProvider>
        {isInternal && <ProductFaq />}
      </DetailErrorWrapper>
    </DetailApi>
  );
}

export default memo(DetailDesktop);
